import red from 'material-ui/colors/red';

const styles = theme => ({
    table: {
        minWidth: 700,
        overflowX: 'auto',
    },
    tableCell: {
        padding: '4px 15px 4px 20px',
        cursor: 'default'
    },
    tableIconBtn: {
        textAlign: 'center',
        padding: '5px 15px 5px 0',
    },
    rootMenusTable: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    headerLabels: {
        fontWeight: '700',
        fontSize: '0.9rem',
    },
    menuTree: {
        height: 700,
    },
    menuViewTree: {
        minHeight: 700
    },
    dialogActionsButtons: {
        padding: '0 18px 20px'
    },
    addMenuItemBtn: {
        marginLeft: '15px'
    },
    selectMenuClass: {
        width: '250px',
        marginLeft: 20
    },
    selectMenuType: {
        width: '200px',
        marginRight: 20
    },
    inputMenuTitle: {
        marginRight: 15,
        height: '32px',
        width: 300
    },
    deletedMenuItem: {
        color: red[800],
        marginLeft: '15px',
        fontSize: '11px'
    },
    selectMenuItem: {
        fontSize: '14px',
        padding: '0 15px'
    },
    selectMenuItemAddTranslation: {
        fontSize: '14px',
        padding: '0 10px'
    },
    menusButtons: {
        marginTop: '25px',
    },
    inputLink: {
        margin: '0 20px 0 20px',
        height: '32px'
    },
    externalMenuUrlError: {
        color: red[500],
        position: 'absolute',
        top: 43,
        left: 585,
    },
    menuNameError: {
        color: red[500],
        position: 'absolute',
        top: 43,
        left: 10,
    },
    menuTypeError: {
        color: red[500],
        position: 'absolute',
        top: 43,
        left: 345,
    },
    selectedPageInfoText: {
        position: 'absolute',
        top: 43,
        left: 345,
    },
    [theme.breakpoints.up('sm')]: {
        root: {
            width: '90%',
        },
    },
    [theme.breakpoints.up('md')]: {
        root: {
            width: '95%',
        },
    },
    [theme.breakpoints.up('lg')]: {
        root: {
            width: '97%',
        },
    },
    [theme.breakpoints.up('xl')]: {
        root: {
            width: '100%',
        },
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/menus/style/styles.js